module.exports = __webpack_public_path__ + "static/media/UNKNOWN_WITH_CATS.c17ef023.svg";